import * as React from "react"
import "./src/styles/global.css"
import { StoreProvider } from "./src/context/store-context"

export const wrapRootElement = ({ element }) => <StoreProvider>{element}</StoreProvider>
